import script from "./autoComplete.vue?vue&type=script&setup=true&lang=js"
export * from "./autoComplete.vue?vue&type=script&setup=true&lang=js"

import "./autoComplete.vue?vue&type=style&index=0&id=3fca6f99&lang=scss&scoped=true"

import exportComponent from "/home/pilki/freelaix/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3fca6f99"]])

export default __exports__